import { Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { UserGroups } from "../../assets/config/models";
import { AuthService } from "./authService";

let groupTypes = UserGroups;

@Injectable({ providedIn: "root" })
export class OnlyLoggedInUsersGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly authService: AuthService = inject(AuthService);
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      return true;
    } else {
      return this.router.createUrlTree(["/auth/login"]);
    }
  }
}

@Injectable()
export class OnlyAdminGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  canActivate() {
    const userDetails = localStorage.getItem("user_details");
    if (!userDetails) {
      return false;
    }
    const groupName = JSON.parse(userDetails).group;
    if (groupName == groupTypes.ADMIN) {
      return true;
    } else {
      this.router.navigate(["/user/home"]);
      return false;
    }
  }
}
